// Sitewide scripts
$(document).ready(function () {
  // $(".hm_sign-tab").click(function () {
  //   $(this).closest(".hm_sign-box-outer").find(".hm_sign-box").slideToggle();
  // });

  $(document).on("click", ".hm_sign-tab", function () {
    var $outer = $(this).closest(".hm_sign-box-outer");
    var $content = $outer.find(".hm_sign-box");
    var isOpen = $outer.hasClass("active") || $content.is(":visible");

    // Close all other tabs at the same level
    $outer
      .siblings(".hm_sign-box-outer")
      .removeClass("active")
      .find(".hm_sign-box")
      .stop(true, true)
      .slideUp();

    // Toggle the clicked one (close if open, open if closed)
    if (isOpen) {
      $outer.removeClass("active");
      $content.stop(true, true).slideUp();
    } else {
      $outer.addClass("active");
      $content.stop(true, true).slideDown();
    }
  });

  $(".hm_reviews-toggle").click(function () {
    $(this).toggleClass("active");
    $(".hidedByDefault").slideToggle();
  });

  $(".hm_offer-cell").click(function () {
    $(this)
      .closest(".hm_offer-grid")
      .find(".hm_offer-cell")
      .removeClass("active");
    $(this).addClass("active");

    var currentQty = $(this).attr("data-qty");
    $(this)
      .closest(".home_page-width")
      .find(".hm_offer-quantity")
      .attr("value", currentQty);
  });

  // $(".hm_faq-box").click(function () {
  //   $(this).toggleClass("active");
  //   $(this).find(".hm_faq-content").slideToggle();
  // });

  $(document).on("click", ".hm_faq-box", function () {
    var $box = $(this);
    var $content = $box.find(".hm_faq-content");

    if ($box.hasClass("active")) {
      // clicked the open one → close it
      $box.removeClass("active");
      $content.stop(true, true).slideUp();
    } else {
      // close others in the same group
      $box
        .siblings(".hm_faq-box.active")
        .removeClass("active")
        .find(".hm_faq-content")
        .stop(true, true)
        .slideUp();

      // open this one
      $box.addClass("active");
      $content.stop(true, true).slideDown();
    }
  });

  $(".home_pdp-offer-sub-switch-btn").click(function (evt) {
    $(".home_pdp-offer-sub-switch-btn").removeClass("active");
    $(this).addClass("active");
    var mode = $(this).attr("data");
    $(".home_pdp-card-price-line").addClass("hided");
    $(".btn_pdp_card-footer").addClass("hided");
    $(".hm_offer-form").addClass("hided");
    $(".home_pdp-card-title").addClass("hided");
    $(".home_pdp-offer-card-badge").addClass("hided");
    if (mode == "sub") {
      $('.home_pdp-card-price-line[data="sub"]').removeClass("hided");
      $('.btn_pdp_card-footer[data="sub"]').removeClass("hided");
      $('.hm_offer-form[data="sub"]').removeClass("hided");
      $('.home_pdp-card-title[data="sub"]').removeClass("hided");
      $('.home_pdp-offer-card-badge[data="sub"]').removeClass("hided");
    } else {
      $('.home_pdp-card-price-line[data="otp"]').removeClass("hided");
      $('.btn_pdp_card-footer[data="otp"]').removeClass("hided");
      $('.hm_offer-form[data="otp"]').removeClass("hided");
      $('.home_pdp-card-title[data="otp"]').removeClass("hided");
      $('.home_pdp-offer-card-badge[data="otp"]').removeClass("hided");
    }
  });

  $(".btn_box-primary").click(function (evt) {
    var mode = $(this).attr("data-mode");
    if (mode == "scroll") {
      evt.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $(".offerScrollTo").offset().top - 100,
        },
        500
      );
    }
  });

  // $(".pdp_offer-card--btn_real").click(function (evt) {
  //   evt.preventDefault();

  //   var titleHandleized = $(this)
  //     .closest(".home_pdp-offer-cell-outer")
  //     .attr("data");

  //   var thisEl = $(this);

  //   jQuery.ajax({
  //     type: "POST",
  //     url: "/cart/clear.js",
  //     dataType: "json",
  //     success: function () {
  //       if (
  //         String(titleHandleized).indexOf("3-monthx") != -1 ||
  //         String(titleHandleized).indexOf("3-packx") != -1
  //       ) {
  //         var items = [];
  //         // var currentId = 51420986802442; //Tweezers
  //         var currentId = 51959385981194; //New tweezers
  //         var currentQty = 1;

  //         // items.push({ id: currentId, quantity: currentQty });

  //         jQuery.ajax({
  //           type: "POST",
  //           url: "/cart/add.js",
  //           data: {
  //             items: items,
  //           },
  //           dataType: "json",
  //           success: function () {
  //             thisEl
  //               .closest(".hm_offer-form")
  //               .find(".pdp_offer-card--btn")
  //               .trigger("click");
  //           },
  //           error: function () {},
  //         });
  //       } else if (
  //         String(titleHandleized).indexOf("6-monthx") != -1 ||
  //         String(titleHandleized).indexOf("6-packx") != -1
  //       ) {
  //         var items = [];
  //         // var currentId = 51420986802442; //Tweezers
  //         var currentId = 51959385981194; //New tweezers
  //         var currentId2 = 51736562696458; //1 pack
  //         var currentQty = 1;

  //         // items.push({ id: currentId, quantity: currentQty });
  //         // items.push({ id: currentId2, quantity: currentQty });

  //         jQuery.ajax({
  //           type: "POST",
  //           url: "/cart/add.js",
  //           data: {
  //             items: items,
  //           },
  //           dataType: "json",
  //           success: function () {
  //             thisEl
  //               .closest(".hm_offer-form")
  //               .find(".pdp_offer-card--btn")
  //               .trigger("click");
  //           },
  //           error: function () {},
  //         });
  //       } else {
  //         thisEl
  //           .closest(".hm_offer-form")
  //           .find(".pdp_offer-card--btn")
  //           .trigger("click");
  //       }
  //     },
  //     error: function () {},
  //   });
  // });

  // $(".pdp_offer-card--btn_real").click(function (evt) {
  //   evt.preventDefault();

  //   var titleHandleized = $(this)
  //     .closest(".home_pdp-offer-cell-outer")
  //     .attr("data");

  //   var thisEl = $(this);

  //   var fromQuiz = false;
  //   if ($(this).attr('data') == 'quiz'){
  //     fromQuiz = true;
  //   }

  //   console.log(fromQuiz, 'from quiz');

  //   jQuery.ajax({
  //     type: "POST",
  //     url: "/cart/clear.js",
  //     dataType: "json",
  //     success: function () {
  //       if (
  //         String(titleHandleized).indexOf("3-monthx") != -1 ||
  //         String(titleHandleized).indexOf("3-packx") != -1
  //       ) {
  //         var items = [];
  //         var currentId = 51959385981194;
  //         var currentQty = 1;
  //         // items.push({ id: currentId, quantity: currentQty });

  //         jQuery.ajax({
  //           type: "POST",
  //           url: "/cart/add.js",
  //           data: { items: items },
  //           dataType: "json",
  //           success: function () {
  //             thisEl
  //               .closest(".hm_offer-form")
  //               .find(".pdp_offer-card--btn")
  //               .trigger("click");

  //             if (fromQuiz == true){
  //               updateAttribute();
  //             }

  //           }
  //         });

  //       } else if (
  //         String(titleHandleized).indexOf("6-monthx") != -1 ||
  //         String(titleHandleized).indexOf("6-packx") != -1
  //       ) {
  //         var items = [];
  //         var currentId = 51959385981194;
  //         var currentId2 = 51736562696458;
  //         var currentQty = 1;
  //         // items.push({ id: currentId, quantity: currentQty });
  //         // items.push({ id: currentId2, quantity: currentQty });

  //         jQuery.ajax({
  //           type: "POST",
  //           url: "/cart/add.js",
  //           data: { items: items },
  //           dataType: "json",
  //           success: function () {
  //             thisEl
  //               .closest(".hm_offer-form")
  //               .find(".pdp_offer-card--btn")
  //               .trigger("click");

  //             if (fromQuiz == true){
  //               updateAttribute();
  //             }
  //           }
  //         });

  //       } else {
  //         thisEl
  //           .closest(".hm_offer-form")
  //           .find(".pdp_offer-card--btn")
  //           .trigger("click");

  //         if (fromQuiz == true){
  //               updateAttribute();
  //         }
  //       }
  //     }
  //   });
  // });

  // ATTRIBUTE UPDATE FUNCTION
  function updateAttribute() {
    $.getJSON("/cart.js", function (cartData) {
      var updatedAttributes = cartData.attributes || {};
      updatedAttributes["order_from_quiz"] = "true";

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: JSON.stringify({ attributes: updatedAttributes }),
        contentType: "application/json",
        dataType: "json",
      });
    });
  }

  let totalSeconds = 30 * 60; // 30 minutes in seconds

  let timer = setInterval(function () {
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;

    $(".hm_offer-timer-mins").text(minutes);
    $(".hm_offer-timer-secs").text(seconds < 10 ? "0" + seconds : seconds);

    if (totalSeconds <= 0) {
      clearInterval(timer);
    }

    totalSeconds--;
  }, 1000);

  new Swiper(".hm_reviews-carousel", {
    slidesPerView: 3,
    spaceBetween: 24,
    loop: true,
    pagination: {
      el: ".hm_reviews-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".hm_reviews-nav-next",
      prevEl: ".hm_reviews-nav-prev",
    },
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const videos = document.querySelectorAll(".hm_image-video-main");

//   videos.forEach(video => {
//     // Make sure requirements for autoplay are set
//     video.muted = true;
//     video.playsInline = true;
//     video.autoplay = true;

//     // Try to play, ignore browser errors
//     video.play().catch(() => {});
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  function attemptPlay(video, overlay) {
    video
      .play()
      .then(() => {
        overlay.style.display = "none";
      })
      .catch(() => {
        // Still blocked → will retry after a user gesture
      });
  }

  // Generic autoplay handler for any pair of (wrapper, video, overlay)
  function processWrapper(wrapperSelector, videoSelector, overlaySelector) {
    document.querySelectorAll(wrapperSelector).forEach((wrapper) => {
      const video = wrapper.querySelector(videoSelector);
      const overlay = wrapper.querySelector(overlaySelector);

      if (!video || !overlay) return;

      // Try autoplay immediately
      attemptPlay(video, overlay);

      // Direct tap → guaranteed to work even in Low Power Mode
      overlay.addEventListener("click", () => {
        attemptPlay(video, overlay);
      });

      // Any user gesture → auto-trigger overlay click
      ["touchstart", "click", "scroll"].forEach((evt) => {
        window.addEventListener(
          evt,
          () => {
            overlay.click();
          },
          { once: true }
        );
      });
    });
  }

  // Apply to hm_image-video-main
  processWrapper(".video-wrapper", "video.hm_image-video-main", ".fake-play");

  // Apply to home_grid-video
  processWrapper(
    ".home-video-wrapper",
    "video.home_grid-video",
    ".home-video-fake-play"
  );
});
